import type { VoidFunctionComponent } from 'react';
import type Stripe from 'stripe-latest';
import { usePlansContext } from './PlansContext';
import Card from '../../../generic/Card/Card';
import LimitsComponent from '../Limits';
import FeaturesComponent from '../Features';
import styles from './styles.module.less';
import Button, { BUTTON_SIZE, BUTTON_TYPE } from '../../../generic/Button';
import { openInNewTab } from '../../../../utils';
import { getBaseOrgProperties, track } from '../../../../helpers/analytics';
import { isOrgInEnterpriseTier } from '../../../../helpers/subscriptions';

const handleContactUsClick = () => {
  track(`Contact Us - Enterprise Upgrade`, getBaseOrgProperties());
  openInNewTab('//fossa.com/request-demo');
};

/**
 * Renders the price component specifically for the ENTERPRISE plan.
 * Displays pricing details and features related to the enterprise pricing tier.
 */
const DisplayEnterprisePlan: VoidFunctionComponent = () => {
  const { enterprisePrice: price } = usePlansContext();
  return (
    <>
      <span className={styles.price}>Custom Pricing</span>
      <Card
        isFullWidth
        padding="xs"
        variant="outline"
      >
        <Card.Content>
          <span className={styles.priceTierDescription}>Unlimited scaling for enterprises</span>
        </Card.Content>
      </Card>
      {isOrgInEnterpriseTier() ?
        <Button
          isFullWidth
          onClick={() => {}}
          size={BUTTON_SIZE.LARGE}
          type={BUTTON_TYPE.SECONDARY}
          isDisabled
        >
          Current Plan
        </Button>
        :
        <Button
          isFullWidth
          onClick={() => handleContactUsClick()}
          size={BUTTON_SIZE.LARGE}
          type={BUTTON_TYPE.DARK}
        >
          Contact Us to Upgrade Plan
        </Button>}

      <LimitsComponent product={price.product as Stripe.Product} />
      <FeaturesComponent product={price.product as Stripe.Product} />
    </>
  );
};

export default DisplayEnterprisePlan;
